import { Box, Divider, Stack, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { type FormData, NotificationsForm } from "./NotificationsForm";
import { NotificationsHistory } from "./NotificationsHistory";
import { NotificationsSend } from "./NotificationsSend";
import { NotificationsTarget, type TargetData } from "./NotificationsTarget";

export const NotificationsContainer = () => {
  const [tab, setTab] = useState(0);
  const [formData, setFormData] = useState<FormData>({
    title: "",
    body: "",
    type: "info",
    platform: "all",
    scheduleEnabled: false,
    scheduledFor: null,
  });

  const [targetData, setTargetData] = useState<TargetData>({
    targetType: null,
    targetValue: null,
    targetUserIds: [],
    selectedApp: null,
    selectedCities: [],
    selectedUsers: [],
    strategy: "everyone",
  });

  return (
    <Box sx={{ padding: "30px" }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="Send Notification" />
        <Tab label="History" />
      </Tabs>

      {tab === 0 && (
        <Stack spacing={4} maxWidth={800}>
          <NotificationsForm formData={formData} setFormData={setFormData} />
          <Divider />
          <NotificationsTarget
            targetData={targetData}
            setTargetData={setTargetData}
          />
          <Divider />
          <NotificationsSend formData={formData} targetData={targetData} />
        </Stack>
      )}

      {tab === 1 && <NotificationsHistory />}
    </Box>
  );
};
